module.exports = __webpack_public_path__ + "static/media/playStore.0bb33404.svg";